const popupBut = () => {
    const popupButs = document.querySelectorAll('.popup-but');

    function popupShow() {
        const popupTarget = this.dataset.pp;
        const popupElem = document.querySelector(`#${popupTarget}`);
        popupElem.classList.add('active');
    }

    popupButs.forEach(but => {
        but.addEventListener('click', popupShow, false);
    });
}

module.exports = popupBut;